(() => {
const advertorial = document.querySelector('[data-nura-advertorial]');
if (!advertorial) return;

const mobileCta = advertorial.querySelector('.mobile-cta');
const hero = advertorial.querySelector('.hero');
const progressBar = advertorial.querySelector('.reading-progress span');
const article = advertorial.querySelector('#article');
const railLinks = [...advertorial.querySelectorAll('.rail a')];

if (mobileCta && hero && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(([entry]) => {
    mobileCta.classList.toggle('is-visible', !entry.isIntersecting);
  }, { threshold: 0.05 });
  observer.observe(hero);
}

advertorial.querySelectorAll('.checklist details').forEach((item) => {
  item.addEventListener('toggle', () => {
    if (!item.open) return;
    advertorial.querySelectorAll('.checklist details').forEach((other) => {
      if (other !== item) other.open = false;
    });
  });
});

const updateReadingProgress = () => {
  if (!progressBar || !article) return;
  const start = article.offsetTop;
  const distance = Math.max(article.offsetHeight - window.innerHeight, 1);
  const progress = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
  progressBar.style.transform = `scaleX(${progress})`;
};

let progressFrame;
window.addEventListener('scroll', () => {
  if (progressFrame) return;
  progressFrame = requestAnimationFrame(() => {
    updateReadingProgress();
    progressFrame = null;
  });
}, { passive: true });
window.addEventListener('resize', updateReadingProgress, { passive: true });
updateReadingProgress();

if (railLinks.length && 'IntersectionObserver' in window) {
  const sections = railLinks
    .map((link) => advertorial.querySelector(link.getAttribute('href')))
    .filter(Boolean);
  const sectionObserver = new IntersectionObserver((entries) => {
    const visible = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
    if (!visible) return;
    railLinks.forEach((link) => {
      const active = link.getAttribute('href') === `#${visible.target.id}`;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }, { rootMargin: '-18% 0px -62% 0px', threshold: [0, 0.2, 0.6] });
  sections.forEach((section) => sectionObserver.observe(section));
}
})();
